import { render } from "./MetadataGroupCard.vue?vue&type=template&id=5e53be19&scoped=true&ts=true"
import script from "./MetadataGroupCard.vue?vue&type=script&lang=ts"
export * from "./MetadataGroupCard.vue?vue&type=script&lang=ts"

import "./MetadataGroupCard.vue?vue&type=style&index=0&id=5e53be19&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e53be19"]])

export default __exports__